module.exports = __webpack_public_path__ + "static/media/LFELTR.d03a789f.svg";